// Szín nevek fordítása color.name alapján.
// Ha egy név nincs itt, fallback: color.name (az adatbázisból jövő eredeti név)

const colorNames = {
  hu: {
    "Y107 - Ice White": "Y107 - Jéghideg Fehér",
    "Y105 - Snow White": "Y105 - Hófehér",
    "Alb Alpin Ultra Mat": "Alpesi Fehér Ultra Matt",
    "Y665 - Apolosa Oak": "Y665 - Apolosa Tölgy",
    "Y668 - Wallpole Oak": "Y668 - Wallpole Tölgy",
    "Y641 - Virginia Chestnut": "Y641 - Virginia Gesztenye",
    "Y629 - Natural Arwen Oak": "Y629 - Natúr Arwen Tölgy",
    "Y628 - Grey Arwen Oak": "Y628 - Szürke Arwen Tölgy",
    "Y627 - White Arwen Oak": "Y627 - Fehér Arwen Tölgy",
    "Y622 - Oxide Vintage Oak": "Y622 - Oxidált Vintage Tölgy",
    "Y621 - Celtis Oak": "Y621 - Celtis Tölgy",
    "Y318 - Slate Grey": "Y318 - Palaszürke",
    "Y345 - Cool Grey": "Y345 - Hűvös Szürke",
    "Y350 - Cashmere": "Y350 - Kasmír",
    "Y572 - Coimbra": "Y572 - Coimbra",
    "Y582 - River Oak": "Y582 - Folyó Tölgy",
    "Y583 - Spanish Oak": "Y583 - Spanyol Tölgy",
    "Y587 - Country Oak": "Y587 - Country Tölgy",
    "Y588 - Brown Country Oak": "Y588 - Barna Country Tölgy",
    "Y611 - Luna Elm": "Y611 - Luna Szil",
    "Y616 - Pearl Calibra": "Y616 - Gyöngy Calibra",
    "Y623 - White Monaco Oak": "Y623 - Fehér Monaco Tölgy",
    "Y624 - Cream Monaco Oak": "Y624 - Krém Monaco Tölgy",
    "Y630 - Grey Freya Oak": "Y630 - Szürke Freya Tölgy",
    "Y631 - Black Freya Oak": "Y631 - Fekete Freya Tölgy",
    "Y640 - Admiral Walnut": "Y640 - Admirális Dió",
    "Y663 - Arctic Pine": "Y663 - Sarki Fenyő",
    "Y697 - Light Rauna Elm": "Y697 - Világos Rauna Szil",
    "Y698 - Dark Rauna Elm": "Y698 - Sötét Rauna Szil",
    "Y103 - Front White": "Y103 - Ellapfehér",
    "Y271 - Anthracite": "Y271 - Antracit",
    "Y301 - Cappuccino": "Y301 - Cappuccino",
    "Y314 - Light Grey": "Y314 - Világosszürke",
    "Y348 - Cream": "Y348 - Krém",
    "Y352 - Latté": "Y352 - Latté",
    "Y353 - Cobalt Grey": "Y353 - Kobaltszürke",
    "Y578 - Brown Vintage Oak": "Y578 - Barna Vintage Tölgy",
    "Y577 - Light Vintage Oak": "Y577 - Világos Vintage Tölgy",
    "Y551 - Dark Plum": "Y551 - Sötét Szilva",
    "Y508 - Alpine Walnut": "Y508 - Alpesi Dió",
    "Y489 - Dark Calvados": "Y489 - Sötét Calvados",
    "Y422 - Hazel": "Y422 - Mogyoró",
    "Y200 - Black": "Y200 - Fekete",
    "Y642 - Dakota Oak": "Y642 - Dakota Tölgy",
    "Y404 - Blossom Cherry": "Y404 - Virágzó Cseresznye",
    "Y121 - Cool White": "Y121 - Hűvös Fehér",
    "Y401 - Savaria Beech": "Y401 - Savaria Bükk",
    "Y586 - Choco Vintage Oak": "Y586 - Csokis Vintage Tölgy",
    "Alb Clasic Ultra Mat": "Klasszikus Fehér Ultra Matt",
    "Albastru Parisian Ultra Mat": "Párizsi Kék Ultra Matt",
    "Alb Ultra Mat": "Fehér Ultra Matt",
    PFL: "PFL",
    "Y351 - Satin": "Y351 - Szatén",
    "Y215 - Orange": "Y215 - Narancs",
    "Y207 - Chilli Red": "Y207 - Chili Piros",
    "Y463 - European Maple": "Y463 - Európai Juhar",
    "F206 ST9 Fekete Pietra Grigia": "F206 ST9 Fekete Pietra Grigia",
    "Y669 - Beneventa": "Y669 - Beneventa",
    "Y673 - Light Kent Oak": "Y673 - Világos Kent Tölgy",
    "Y674 - Natural Kent Oak": "Y674 - Natúr Kent Tölgy",
    "Y675 - Grey Kent Oak": "Y675 - Szürke Kent Tölgy",
    "Y682 - Natural Arcena Oak": "Y682 - Natúr Arcena Tölgy",
    "Y683 - Brown Arcena Oak": "Y683 - Barna Arcena Tölgy",
    "Y687 - Tristan Oak": "Y687 - Tristan Tölgy",
    "Y688 - Natural Othello Ash": "Y688 - Natúr Othello Kőris",
    "Y689 - Brown Othello Ash": "Y689 - Barna Othello Kőris",
    "Y380 - Light Element": "Y380 - Világos Element",
    "Y672 - Brown Partosa Oak": "Y672 - Barna Partosa Tölgy",
    "F221 ST87 Krém Tessina Kerámia": "F221 ST87 Krém Tessina Kerámia",
    "Y671 - Light Partosa Oak": "Y671 - Világos Partosa Tölgy",
    "Y220 - Azure Blue": "Y220 - Azúrkék",
    "F244 ST76 Antracit Candela Márvány": "F244 ST76 Antracit Candela Márvány",
    "H1180 ST37 Halifax Natúr Tölgy": "H1180 ST37 Halifax Natúr Tölgy",
    "H1181 ST37 Halifax Dohány Tölgy": "H1181 ST37 Halifax Dohány Tölgy",
    "H3730 ST10 Natúr Hickory": "H3730 ST10 Natúr Hickory",
    "Y676 - Light Piemona Oak": "Y676 - Világos Piemona Tölgy",
    "Y677 - Natural Piemona Oak": "Y677 - Natúr Piemona Tölgy",
    "Y678 - Brown Piemona Oak": "Y678 - Barna Piemona Tölgy",
    "Y684 - Palas Oak": "Y684 - Palas Tölgy",
    "Y686 - Dark Dylan Oak": "Y686 - Sötét Dylan Tölgy",
    "Y116 - Corpus White": "Y116 - Korpusz Fehér",
    "Y242 - Yellow": "Y242 - Sárga",
    "Y244 - Petrol Blue": "Y244 - Petrolkék",
    "Y275 - Graphite Grey": "Y275 - Grafitszürke",
    "Y410 - Bio Pine": "Y410 - Bio Fenyő",
    "Y438 - Light Beech": "Y438 - Világos Bükk",
    "Y381 - Grey Element": "Y381 - Szürke Element",
    "Y382 - Nebula": "Y382 - Nebula",
    "Y383 - Light Allegro": "Y383 - Világos Allegro",
    "Y387 - Pixel": "Y387 - Pixel",
    "Y617 - Natural Calibra": "Y617 - Natúr Calibra",
    "Y276 - Basalt": "Y276 - Bazalt",
    "Y277 - Steel Grey": "Y277 - Acélszürke",
    "Y278 - Mouse Grey": "Y278 - Egérszürke",
    "Y322 - Aluminium Flash": "Y322 - Alumínium Flash"
  },
  ro: {
    "Y107 - Ice White": "Y107 - Alb Gheață",
    "Y105 - Snow White": "Y105 - Alb Zăpadă",
    "Alb Alpin Ultra Mat": "Alb Alpin Ultra Mat",
    "Y665 - Apolosa Oak": "Y665 - Stejar Apolosa",
    "Y668 - Wallpole Oak": "Y668 - Stejar Wallpole",
    "Y641 - Virginia Chestnut": "Y641 - Castan Virginia",
    "Y629 - Natural Arwen Oak": "Y629 - Stejar Arwen Natural",
    "Y628 - Grey Arwen Oak": "Y628 - Stejar Arwen Gri",
    "Y627 - White Arwen Oak": "Y627 - Stejar Arwen Alb",
    "Y622 - Oxide Vintage Oak": "Y622 - Stejar Vintage Oxidat",
    "Y621 - Celtis Oak": "Y621 - Stejar Celtis",
    "Y318 - Slate Grey": "Y318 - Gri Ardezie",
    "Y345 - Cool Grey": "Y345 - Gri Rece",
    "Y350 - Cashmere": "Y350 - Caşmir",
    "Y572 - Coimbra": "Y572 - Coimbra",
    "Y582 - River Oak": "Y582 - Stejar de Râu",
    "Y583 - Spanish Oak": "Y583 - Stejar Spaniol",
    "Y587 - Country Oak": "Y587 - Stejar Country",
    "Y588 - Brown Country Oak": "Y588 - Stejar Country Maro",
    "Y611 - Luna Elm": "Y611 - Ulm Luna",
    "Y616 - Pearl Calibra": "Y616 - Calibra Perlat",
    "Y623 - White Monaco Oak": "Y623 - Stejar Monaco Alb",
    "Y624 - Cream Monaco Oak": "Y624 - Stejar Monaco Crem",
    "Y630 - Grey Freya Oak": "Y630 - Stejar Freya Gri",
    "Y631 - Black Freya Oak": "Y631 - Stejar Freya Negru",
    "Y640 - Admiral Walnut": "Y640 - Nuc Admiral",
    "Y663 - Arctic Pine": "Y663 - Pin Arctic",
    "Y697 - Light Rauna Elm": "Y697 - Ulm Rauna Deschis",
    "Y698 - Dark Rauna Elm": "Y698 - Ulm Rauna Închis",
    "Y103 - Front White": "Y103 - Alb Frontal",
    "Y271 - Anthracite": "Y271 - Antracit",
    "Y301 - Cappuccino": "Y301 - Cappuccino",
    "Y314 - Light Grey": "Y314 - Gri Deschis",
    "Y348 - Cream": "Y348 - Crem",
    "Y352 - Latté": "Y352 - Latté",
    "Y353 - Cobalt Grey": "Y353 - Gri Cobalt",
    "Y578 - Brown Vintage Oak": "Y578 - Stejar Vintage Maro",
    "Y577 - Light Vintage Oak": "Y577 - Stejar Vintage Deschis",
    "Y551 - Dark Plum": "Y551 - Prună Închisă",
    "Y508 - Alpine Walnut": "Y508 - Nuc Alpin",
    "Y489 - Dark Calvados": "Y489 - Calvados Închis",
    "Y422 - Hazel": "Y422 - Alun",
    "Y200 - Black": "Y200 - Negru",
    "Y642 - Dakota Oak": "Y642 - Stejar Dakota",
    "Y404 - Blossom Cherry": "Y404 - Cireș Înflorit",
    "Y121 - Cool White": "Y121 - Alb Rece",
    "Y401 - Savaria Beech": "Y401 - Fag Savaria",
    "Y586 - Choco Vintage Oak": "Y586 - Stejar Vintage Ciocolată",
    "Alb Clasic Ultra Mat": "Alb Clasic Ultra Mat",
    "Albastru Parisian Ultra Mat": "Albastru Parisian Ultra Mat",
    "Alb Ultra Mat": "Alb Ultra Mat",
    PFL: "PFL",
    "Y351 - Satin": "Y351 - Satin",
    "Y215 - Orange": "Y215 - Portocaliu",
    "Y207 - Chilli Red": "Y207 - Roșu Chili",
    "Y463 - European Maple": "Y463 - Arțar European",
    "F206 ST9 Fekete Pietra Grigia": "F206 ST9 Pietra Grigia Neagră",
    "Y669 - Beneventa": "Y669 - Beneventa",
    "Y673 - Light Kent Oak": "Y673 - Stejar Kent Deschis",
    "Y674 - Natural Kent Oak": "Y674 - Stejar Kent Natural",
    "Y675 - Grey Kent Oak": "Y675 - Stejar Kent Gri",
    "Y682 - Natural Arcena Oak": "Y682 - Stejar Arcena Natural",
    "Y683 - Brown Arcena Oak": "Y683 - Stejar Arcena Maro",
    "Y687 - Tristan Oak": "Y687 - Stejar Tristan",
    "Y688 - Natural Othello Ash": "Y688 - Frasin Othello Natural",
    "Y689 - Brown Othello Ash": "Y689 - Frasin Othello Maro",
    "Y380 - Light Element": "Y380 - Element Deschis",
    "Y672 - Brown Partosa Oak": "Y672 - Stejar Partosa Maro",
    "F221 ST87 Krém Tessina Kerámia": "F221 ST87 Ceramică Tessina Crem",
    "Y671 - Light Partosa Oak": "Y671 - Stejar Partosa Deschis",
    "Y220 - Azure Blue": "Y220 - Albastru Azur",
    "F244 ST76 Antracit Candela Márvány": "F244 ST76 Marmură Candela Antracit",
    "H1180 ST37 Halifax Natúr Tölgy": "H1180 ST37 Stejar Halifax Natural",
    "H1181 ST37 Halifax Dohány Tölgy": "H1181 ST37 Stejar Halifax Tutun",
    "H3730 ST10 Natúr Hickory": "H3730 ST10 Hickory Natural",
    "Y676 - Light Piemona Oak": "Y676 - Stejar Piemona Deschis",
    "Y677 - Natural Piemona Oak": "Y677 - Stejar Piemona Natural",
    "Y678 - Brown Piemona Oak": "Y678 - Stejar Piemona Maro",
    "Y684 - Palas Oak": "Y684 - Stejar Palas",
    "Y686 - Dark Dylan Oak": "Y686 - Stejar Dylan Închis",
    "Y116 - Corpus White": "Y116 - Alb Corp",
    "Y242 - Yellow": "Y242 - Galben",
    "Y244 - Petrol Blue": "Y244 - Albastru Petrol",
    "Y275 - Graphite Grey": "Y275 - Gri Grafit",
    "Y410 - Bio Pine": "Y410 - Pin Bio",
    "Y438 - Light Beech": "Y438 - Fag Deschis",
    "Y381 - Grey Element": "Y381 - Element Gri",
    "Y382 - Nebula": "Y382 - Nebulă",
    "Y383 - Light Allegro": "Y383 - Allegro Deschis",
    "Y387 - Pixel": "Y387 - Pixel",
    "Y617 - Natural Calibra": "Y617 - Calibra Natural",
    "Y276 - Basalt": "Y276 - Bazalt",
    "Y277 - Steel Grey": "Y277 - Gri Oțel",
    "Y278 - Mouse Grey": "Y278 - Gri Șoarece",
    "Y322 - Aluminium Flash": "Y322 - Flash Aluminiu"
  },
  en: {
    "Y107 - Ice White": "Y107 - Ice White",
    "Y105 - Snow White": "Y105 - Snow White",
    "Alb Alpin Ultra Mat": "Alpine White Ultra Matt",
    "Y665 - Apolosa Oak": "Y665 - Apolosa Oak",
    "Y668 - Wallpole Oak": "Y668 - Wallpole Oak",
    "Y641 - Virginia Chestnut": "Y641 - Virginia Chestnut",
    "Y629 - Natural Arwen Oak": "Y629 - Natural Arwen Oak",
    "Y628 - Grey Arwen Oak": "Y628 - Grey Arwen Oak",
    "Y627 - White Arwen Oak": "Y627 - White Arwen Oak",
    "Y622 - Oxide Vintage Oak": "Y622 - Oxide Vintage Oak",
    "Y621 - Celtis Oak": "Y621 - Celtis Oak",
    "Y318 - Slate Grey": "Y318 - Slate Grey",
    "Y345 - Cool Grey": "Y345 - Cool Grey",
    "Y350 - Cashmere": "Y350 - Cashmere",
    "Y572 - Coimbra": "Y572 - Coimbra",
    "Y582 - River Oak": "Y582 - River Oak",
    "Y583 - Spanish Oak": "Y583 - Spanish Oak",
    "Y587 - Country Oak": "Y587 - Country Oak",
    "Y588 - Brown Country Oak": "Y588 - Brown Country Oak",
    "Y611 - Luna Elm": "Y611 - Luna Elm",
    "Y616 - Pearl Calibra": "Y616 - Pearl Calibra",
    "Y623 - White Monaco Oak": "Y623 - White Monaco Oak",
    "Y624 - Cream Monaco Oak": "Y624 - Cream Monaco Oak",
    "Y630 - Grey Freya Oak": "Y630 - Grey Freya Oak",
    "Y631 - Black Freya Oak": "Y631 - Black Freya Oak",
    "Y640 - Admiral Walnut": "Y640 - Admiral Walnut",
    "Y663 - Arctic Pine": "Y663 - Arctic Pine",
    "Y697 - Light Rauna Elm": "Y697 - Light Rauna Elm",
    "Y698 - Dark Rauna Elm": "Y698 - Dark Rauna Elm",
    "Y103 - Front White": "Y103 - Front White",
    "Y271 - Anthracite": "Y271 - Anthracite",
    "Y301 - Cappuccino": "Y301 - Cappuccino",
    "Y314 - Light Grey": "Y314 - Light Grey",
    "Y348 - Cream": "Y348 - Cream",
    "Y352 - Latté": "Y352 - Latté",
    "Y353 - Cobalt Grey": "Y353 - Cobalt Grey",
    "Y578 - Brown Vintage Oak": "Y578 - Brown Vintage Oak",
    "Y577 - Light Vintage Oak": "Y577 - Light Vintage Oak",
    "Y551 - Dark Plum": "Y551 - Dark Plum",
    "Y508 - Alpine Walnut": "Y508 - Alpine Walnut",
    "Y489 - Dark Calvados": "Y489 - Dark Calvados",
    "Y422 - Hazel": "Y422 - Hazel",
    "Y200 - Black": "Y200 - Black",
    "Y642 - Dakota Oak": "Y642 - Dakota Oak",
    "Y404 - Blossom Cherry": "Y404 - Blossom Cherry",
    "Y121 - Cool White": "Y121 - Cool White",
    "Y401 - Savaria Beech": "Y401 - Savaria Beech",
    "Y586 - Choco Vintage Oak": "Y586 - Choco Vintage Oak",
    "Alb Clasic Ultra Mat": "Classic White Ultra Matt",
    "Albastru Parisian Ultra Mat": "Parisian Blue Ultra Matt",
    "Alb Ultra Mat": "White Ultra Matt",
    PFL: "PFL",
    "Y351 - Satin": "Y351 - Satin",
    "Y215 - Orange": "Y215 - Orange",
    "Y207 - Chilli Red": "Y207 - Chilli Red",
    "Y463 - European Maple": "Y463 - European Maple",
    "F206 ST9 Fekete Pietra Grigia": "F206 ST9 Black Pietra Grigia",
    "Y669 - Beneventa": "Y669 - Beneventa",
    "Y673 - Light Kent Oak": "Y673 - Light Kent Oak",
    "Y674 - Natural Kent Oak": "Y674 - Natural Kent Oak",
    "Y675 - Grey Kent Oak": "Y675 - Grey Kent Oak",
    "Y682 - Natural Arcena Oak": "Y682 - Natural Arcena Oak",
    "Y683 - Brown Arcena Oak": "Y683 - Brown Arcena Oak",
    "Y687 - Tristan Oak": "Y687 - Tristan Oak",
    "Y688 - Natural Othello Ash": "Y688 - Natural Othello Ash",
    "Y689 - Brown Othello Ash": "Y689 - Brown Othello Ash",
    "Y380 - Light Element": "Y380 - Light Element",
    "Y672 - Brown Partosa Oak": "Y672 - Brown Partosa Oak",
    "F221 ST87 Krém Tessina Kerámia": "F221 ST87 Cream Tessina Ceramic",
    "Y671 - Light Partosa Oak": "Y671 - Light Partosa Oak",
    "Y220 - Azure Blue": "Y220 - Azure Blue",
    "F244 ST76 Antracit Candela Márvány": "F244 ST76 Anthracite Candela Marble",
    "H1180 ST37 Halifax Natúr Tölgy": "H1180 ST37 Halifax Natural Oak",
    "H1181 ST37 Halifax Dohány Tölgy": "H1181 ST37 Halifax Tobacco Oak",
    "H3730 ST10 Natúr Hickory": "H3730 ST10 Natural Hickory",
    "Y676 - Light Piemona Oak": "Y676 - Light Piemona Oak",
    "Y677 - Natural Piemona Oak": "Y677 - Natural Piemona Oak",
    "Y678 - Brown Piemona Oak": "Y678 - Brown Piemona Oak",
    "Y684 - Palas Oak": "Y684 - Palas Oak",
    "Y686 - Dark Dylan Oak": "Y686 - Dark Dylan Oak",
    "Y116 - Corpus White": "Y116 - Corpus White",
    "Y242 - Yellow": "Y242 - Yellow",
    "Y244 - Petrol Blue": "Y244 - Petrol Blue",
    "Y275 - Graphite Grey": "Y275 - Graphite Grey",
    "Y410 - Bio Pine": "Y410 - Bio Pine",
    "Y438 - Light Beech": "Y438 - Light Beech",
    "Y381 - Grey Element": "Y381 - Grey Element",
    "Y382 - Nebula": "Y382 - Nebula",
    "Y383 - Light Allegro": "Y383 - Light Allegro",
    "Y387 - Pixel": "Y387 - Pixel",
    "Y617 - Natural Calibra": "Y617 - Natural Calibra",
    "Y276 - Basalt": "Y276 - Basalt",
    "Y277 - Steel Grey": "Y277 - Steel Grey",
    "Y278 - Mouse Grey": "Y278 - Mouse Grey",
    "Y322 - Aluminium Flash": "Y322 - Aluminium Flash"
  }
};

export default colorNames;
